import React, { FC } from 'react';
import styles from './MissionStatement.module.scss';
import Stack from "@mui/material/Stack";
import {Link} from "react-router-dom";
import Liberty from "../../../assets/images/Liberty.jpg";
import {Helmet} from "react-helmet";

interface MissionStatementProps {}

const MissionStatement: FC<MissionStatementProps> = () => (
  <div className={styles.MissionStatement}>

      <Helmet>
          <meta charSet="utf-8"/>
          <title>MIssion Statement</title>
      </Helmet>

      <div className="standard-margin">
          <h1>Mission Statement</h1>
          <hr></hr>
          <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
          >

          <span>
             <p>The Technical Information Center (TIC) provides planning, design, and construction information and research assistance
                 for National Park Service (NPS) employees and the public. TIC is committed to preserve the institutional technical
                 memory of our park infrastructure by serving as the central repository for NPS generated documents in a variety of media.
                 We also share a commitment to preserve and make available original National Park Service documents by offering archival
                 technical assistance on document preservation, storage, and by hosting our collection online. TIC collects, maintains,
                 and provides access to relevant informational resources to further enable NPS employees to perform their jobs.
                             </p>
              <br></br>
                 <p>
                 The National Park Service designated the Technical Information Center as the central repository for all NPS‑generated planning, design, construction drawings and related technical report documents. eTIC (electronic Technical Information Center)
                 is the electronic document management system used to manage these documents and drawings.</p>

          </span>
              <div className= {styles.container}>
              <div>
               <a href={require('../../../assets/images/Liberty.jpg')}>
               <img src={Liberty} alt="team" className={styles.liberty}/></a>
              </div>
              <br></br>

               <div className={styles.footnote}>
                   Foundation Document
                   <br></br>
                   (Statue of Liberty and Ellis Island)</div>
              </div>

          </Stack>


  </div>
  </div>
);

export default MissionStatement;
